export default __webpack_public_path__ + "static/media/book-inside.e0c618f6.png";